<div id="sidepanels">
    <se-text id="sidepanel_handle" title="ui.panel_action" text="ui.panel"></se-text>
    <div id="sidepanel_content">
        <div id="layerpanel">
            <se-text id="layersLabel" text="layers.layers"></se-text>
            <fieldset id="layerbuttons">
                <se-button id="layer_new" title="layers.new" size="small" src="new.svg"></se-button>
                <se-button id="layer_delete" title="layers.del" size="small" src="delete.svg"></se-button>
                <se-button id="layer_rename" title="layers.rename" size="small" src="text.svg"></se-button>
                <se-button id="layer_up" title="layers.move_up" size="small" src="go_up.svg"></se-button>
                <se-button id="layer_down" title="layers.move_down" size="small" src="go_down.svg"></se-button>
                <se-button id="layer_moreopts" title="common.more_opts" size="small" src="context_menu.svg">
                </se-button>
            </fieldset>
            <div id="layer_tree_scroll">
                <table id="layerlist" role="tree" aria-multiselectable="true"><tbody role="none"></tbody></table>
            </div>
            <label for="selLayerNames"><se-text text="layers.move_elems_to"></se-text></label>
            <select id="selLayerNames" disabled></select>
            <p id="layer_tree_error" role="alert"></p>
            <dialog id="layer_move_dialog" aria-labelledby="layer_move_title">
                <form id="layer_move_form">
                    <h2 id="layer_move_title"></h2>
                    <label id="layer_move_destination_label" for="layer_move_destination"></label>
                    <select id="layer_move_destination"></select>
                    <div id="layer_move_name_wrap" hidden>
                        <label id="layer_move_name_label" for="layer_move_name"></label>
                        <input id="layer_move_name" type="text" autocomplete="off">
                    </div>
                    <p id="layer_move_error" role="alert"></p>
                    <div class="layer-dialog-actions">
                        <button id="layer_move_cancel" type="button"></button>
                        <button id="layer_move_confirm" type="submit"></button>
                    </div>
                </form>
            </dialog>
        </div>
    </div>
</div>